/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AuthContainer from './AuthContainer.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import PasswordConfirmation from 'shared/ui/components/form-components/PasswordConfirmation.vue';

// Mixins
import errorHandler from 'auth/mixins/errorHandler';

const __vue_script__ = {
    name: 'NewPassword',

    components: {
        AuthContainer,
        BaseInput,
        PasswordConfirmation,
    },

    mixins: [errorHandler],

    props: {
        resetToken: {
            type: String,
            default: null
        },

        resetEmail: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            email: this.resetEmail,
            errorMessage: null,
            password: null,
            submitting: false,
        };
    },

    methods: {
        async setNewPassword() {
            try {
                this.reset();

                const zxcvbn = await System.import(`${window.BSTG.extLibs}/zxcvbn.js`);
                const { score } = zxcvbn(this.password);

                if (score < 2) {
                    this.errorMessage = 'login.messages.weak_password';
                    return;
                }

                this.submitting = true;

                const { data } = await this.$services.account.resetPassword(this.resetToken, this.email, this.password);

                if (!data.ok && data.mfa_token) {
                    this.$router.push({
                        path: this.$const.ROUTE_RESET_PASSWORD_MFA,
                        query: { mfa_token: data.mfa_token, phone_digits: data.phoneDigits },
                    });
                    return;
                }

                console.info('[NewPassword] Password successfully resetted', data);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('login.messages.password_resetted').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$router.push(this.$const.ROUTE_LOGIN);

            } catch (error) {
                this.handleError(error);

            } finally {
                this.submitting = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',{attrs:{"back-to-login-in-header":true}},[_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"new-password",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.setNewPassword)}}},[_c('h2',[_vm._v(_vm._s(_vm.$t('login.forms.fieldsets.reset_password')))]),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-error"},[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.errorMessage, _vm.errorMessageReplacements)))])]):_vm._e(),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"email"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"username",attrs:{"label":_vm.$t('login.forms.password_form.your_email'),"placeholder":_vm.$t('login.forms.email'),"type":"email","name":"email","errors":errors,"autocomplete":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"password"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('password-confirmation',{attrs:{"errors":errors,"password-label":_vm.$t('login.forms.password_form.new_password.label'),"password-placeholder":_vm.$t('login.forms.password_form.new_password.placeholder'),"confirm-label":_vm.$t('login.forms.password_form.confirmation.label'),"confirm-placeholder":_vm.$t('login.forms.password_form.confirmation.placeholder')},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})]}}],null,true)}),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"action"},[_c('router-link',{staticClass:"forgot-password",attrs:{"to":_vm.$const.ROUTE_SEND_RESET_TOKEN}},[_vm._v(_vm._s(_vm.$t('login.links.request_new_token')))])],1),_c('div',{staticClass:"action"},[_c('button',{staticClass:"btn btn-login",attrs:{"disabled":_vm.submitting}},[_vm._v(_vm._s(_vm.$t('login.forms.actions.change_password')))])])])],1)]}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "NewPassword.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__